import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/iview.js'
import { apolloProvider } from './vue-apollo'

Vue.config.productionTip = false
export const bus = new Vue();

Vue.filter('currencyFilter', function (val) {
  return  ![null, undefined].includes(val)?val.toLocaleString('en-IN', { minimumFractionDigits:0, style: 'currency', currency: 'INR' }).replace(/₹/g, '₹ '):'₹ 0'
})

Object.defineProperty(Object, "copyExistingKeys", {
  value: (target, source) => {
    'use strict';
    if(target === null || target === undefined) {
      throw new TypeError('Cannot convert undefined or null to object');
    }
    Object.keys(target).forEach(key => {
      if (key in source) target[key] = source[key];
    });
  },
  writable: true,
  configurable: true,
});

new Vue({
  router,
  store,
  apolloProvider,
  render: h => h(App)
}).$mount('#app')
